"use client";

const LOGO_SIZE = 80;

// Icons are local copies of the corresponding simple-icons assets
// (see public/icons/*.svg) — no runtime dependency on cdn.simpleicons.org.
const LOGOS = [
  { name: "Next.js", src: "/icons/nextdotjs.svg" },
  { name: "Node.js", src: "/icons/nodedotjs.svg" },
  { name: "PostgreSQL", src: "/icons/postgresql.svg" },
  { name: "Python", src: "/icons/python.svg" },
  { name: "Ubuntu", src: "/icons/ubuntu.svg" },
  { name: "Nginx", src: "/icons/nginx.svg" },
  { name: "WordPress", src: "/icons/wordpress.svg" },
];

function LogoItem({ name, src }: (typeof LOGOS)[0]) {
  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-2xl bg-white/40 px-6 py-4 ring-1 ring-white/30 backdrop-blur-xl dark:bg-white/10 dark:ring-white/20"
      title={name}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt={name}
        width={LOGO_SIZE}
        height={LOGO_SIZE}
        className="h-12 w-12 object-contain md:h-14 md:w-14"
      />
    </div>
  );
}

export function TechnologiesCarousel() {
  return (
    <div className="relative w-full overflow-hidden">
      <div className="flex gap-6 animate-technologies-scroll">
        {/* Duplicate set for seamless loop */}
        {[...LOGOS, ...LOGOS].map((logo, i) => (
          <LogoItem key={`${logo.src}-${i}`} {...logo} />
        ))}
      </div>
    </div>
  );
}
